import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import userDetails from "../services/slices/userDetails";
import timeZoneSlice from "../services/slices/timeZoneSlice";
import airPortsSlice from "../services/slices/airPortsSlice";
import selectedShops from "../services/slices/selectedShops";
import myMarketSlice from "../services/slices/myMarketSlice";
import snackBarSlice from "../services/slices/snackBarSlice";
import authTokenSlice from "../services/slices/authTokenSlice";
import scoreCardSlice from "../services/slices/scoreCard";
import FilterFormSlice from "../services/slices/filterFormDatas"
import sourceDataSlice from "../services/slices/sourceDataSlice";
import currentTabSlice from "../services/slices/currentTab";
import userAirlineSlice from "../services/slices/userAirlineSlice";
import getAirlinesSlice from "../services/slices/getAirlinesSlice";
import marketGroupSlice from "../services/slices/marketGroupSlice";
import fetchAirlineSlice from "../services/slices/fetchAirlineSlice";
import addFlightShopSlice from "../services/slices/addFlightShopSlice";
import editFlightShopSlice from "../services/slices/editFlightShopSlice";
import getAirlinesByRoutesIataSlice from "../services/slices/getAirlinesByRoutesIataSlice";
import librerySlice from "../services/slices/librerySlice";
import dashboardDataSlice from "../services/slices/dashboardDataSlice";
import allGroupSlice from "../services/slices/allGroupSlice";
import localForage from "localforage";
import tableauLibrarySliceData from "../services/slices/tableauLibraryItems";
import shopStatus from "../services/slices/shopStatus";
import addformSlice from "../services/slices/addformSlice";

const PersistConfig = {
  key: "root",
  storage: localForage,
  // v1: sessions moved to httpOnly cookies. Drop auth state persisted by older builds, which held
  // the bearer token in IndexedDB; those users sign in again.
  version: 1,
  migrate: (state) => Promise.resolve(
    state?.authToken?.authTokenResponseData?.accessToken ? { ...state, authToken: undefined } : state
  ),
};
// Dispatched on logout / session end: returns every slice to its initialState
export const RESET_STORE = "app/resetStore";
export const resetStore = () => ({ type: RESET_STORE });

const appReducer = combineReducers({
  authToken: authTokenSlice,
  timezone: timeZoneSlice,
  userAirline: userAirlineSlice,
  airports: airPortsSlice,
  getAirlines: getAirlinesSlice,
  myMarketSlice: myMarketSlice,
  addFlightShop: addFlightShopSlice,
  scoreCard: scoreCardSlice,
  MarketGroup: marketGroupSlice,
  MyMarket: myMarketSlice,
  fetchAirline: fetchAirlineSlice,
  editFlightShop: editFlightShopSlice,
  getAirlinesByRoutesIata: getAirlinesByRoutesIataSlice,
  userDetails: userDetails,
  source: sourceDataSlice,
  snackBar: snackBarSlice,
  filterForm: FilterFormSlice,
  currentTab: currentTabSlice,
  selectedShopData: selectedShops,
  librery: librerySlice,
  dashboardData: dashboardDataSlice,
  allGroups: allGroupSlice,
  tableauLibraryItems :tableauLibrarySliceData,
  shopStatus: shopStatus,
  addShop: addformSlice,

});
const rootReducer = (state, action) =>
  appReducer(action.type === RESET_STORE ? undefined : state, action);
const persistedReducer = persistReducer(PersistConfig, rootReducer);

// Configure and create the Redux store
// Set the reducer to the persisted reducer
// Define middleware options
// Disable serializable check middleware
// Disable Redux DevTools in production environment

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
